import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NoResultComponent } from '../../../no-result/no-result.component';

@Component({
  selector: 'app-pre-render-home',
  standalone: true,
  imports: [NoResultComponent],
  templateUrl: './pre-render-home.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PreRenderHomeComponent {}
